import {AsYouType, CountryCode} from 'libphonenumber-js';
import {useRecoilValue} from 'recoil';
import {localeState} from './Atoms';
import {ITimeZone, timeZoneToLocale} from './mappingTimeZoneLocale';
import {countryArray, ILocale} from 'data/country';

/**
 * 로케일 타입 변경
 * @param locale - 로케일 문자열
 * @returns 국가 코드
 * @public
 */
export const changeLocaleType = (locale: string): CountryCode => {
  if (locale.length === 5) {
    return locale.substring(3, 5) as CountryCode;
  } else {
    return locale as CountryCode;
  }
};

/**
 * 전화번호 포맷팅 (Recoil 사용)
 * @param phone - 전화번호
 * @returns 포맷팅된 전화번호
 * @public
 */
export const fomatPhoneNumber = (phone: string) => {
  const locale: CountryCode = changeLocaleType(useRecoilValue(localeState));
  try {
    const fomattedNumber = new AsYouType(locale).input(phone);
    const removeHyphen = fomattedNumber.replace(/-/gi, ' ').toString();
    return removeHyphen;
  } catch {
    return phone;
  }
};

/**
 * locale에 따라 전화번호 형식 변경
 * @param params - 전화번호 포맷팅 파라미터
 * @param params.phone - 전화번호
 * @param params.locale - 로케일 (선택)
 * @param params.timeZone - 타임존 (선택)
 * @returns 포맷팅된 전화번호
 * @public
 */
export const formatPhoneNumber = ({
  phone,
  locale,
  timeZone,
}: {
  phone: string;
  locale?: string;
  timeZone?: ITimeZone;
}) => {
  let languageCode = locale;
  if (timeZone) languageCode = timeZoneToLocale(timeZone);

  const countryCode: CountryCode =
    countryArray.find(country => country.languageCode === languageCode)
      ?.countryCode || 'KR';

  let formattedValue = new AsYouType(countryCode).input(phone);

  formattedValue = formattedValue.replace(/-/gi, ' ').toString();

  if (formattedValue.slice(-1) === ')') {
    formattedValue = formattedValue.slice(0, -1);
  }

  return formattedValue;
};
